const renderFindationWidget = ({
  buttonId,
  productUrl,
  productId,
}) => {
  (function() {
    ;window.Modernizr=function(a,b,c){function t(a){i.cssText=a}function u(a,b){return t(prefixes.join(a+";")+(b||""))}function v(a,b){return typeof a===b}function w(a,b){return!!~(""+a).indexOf(b)}function x(a,b,d){for(var e in a){var f=b[a[e]];if(f!==c)return d===!1?a[e]:v(f,"function")?f.bind(d||b):f}return!1}var d="2.6.2",e={},f=b.documentElement,g="modernizr",h=b.createElement(g),i=h.style,j,k={}.toString,l={},m={},n={},o=[],p=o.slice,q,r={}.hasOwnProperty,s;!v(r,"undefined")&&!v(r.call,"undefined")?s=function(a,b){return r.call(a,b)}:s=function(a,b){return b in a&&v(a.constructor.prototype[b],"undefined")},Function.prototype.bind||(Function.prototype.bind=function(b){var c=this;if(typeof c!="function")throw new TypeError;var d=p.call(arguments,1),e=function(){if(this instanceof e){var a=function(){};a.prototype=c.prototype;var f=new a,g=c.apply(f,d.concat(p.call(arguments)));return Object(g)===g?g:f}return c.apply(b,d.concat(p.call(arguments)))};return e}),l.postmessage=function(){return!!a.postMessage};for(var y in l)s(l,y)&&(q=y.toLowerCase(),e[q]=l[y](),o.push((e[q]?"":"no-")+q));return e.addTest=function(a,b){if(typeof a=="object")for(var d in a)s(a,d)&&e.addTest(d,a[d]);else{a=a.toLowerCase();if(e[a]!==c)return e;b=typeof b=="function"?b():b,typeof enableClasses!="undefined"&&enableClasses&&(f.className+=" "+(b?"":"no-")+a),e[a]=b}return e},t(""),h=j=null,e._version=d,e}(this,this.document);
  
    if(!Modernizr.postmessage) {
      // Can't embed
      return;
    }
    var el = document.getElementById(buttonId);
    var targetProductId = el.getAttribute("data-product-id") || "";
    var targetAPIKey    = el.getAttribute("data-api-key") || "";
    var domain = el.getAttribute("data-findation-url") || "https://findation.com";
    var urlArgs = el.getAttribute("data-mode") || "none"
  
    var bind = function(element, name, callback) {
      if (element.addEventListener) {
        return element.addEventListener(name, callback, false);
      } else {
        return element.attachEvent("on" + name, callback);
      }
    };
  
    var insert = function(element, child) {
      return element.parentNode.insertBefore(child, element);
    };
  
    var findationUrl = function(path){
      // return domain + path + "&host=" + encodeURIComponent(document.location.host) + "&href=" + encodeURIComponent(document.location.href);
      return domain + path + "&host=" + encodeURIComponent(document.location.host) + "&href=" + encodeURIComponent(productUrl);
    }
  
    var buttonFrame = document.createElement("iframe")
    var buttonFrameCss = "background-color: transparent; border: 0px none transparent; overflow: hidden; display: inline-block; visibility: visible; margin: 0px; padding: 0px; height: 0px; width: 0px;";
  
    buttonFrame.id = `findation-button-iframe-${productId}`;
    buttonFrame.style.cssText = buttonFrameCss;
    buttonFrame.title = "Find Your Shade";
    buttonFrame.src = findationUrl("/embed/button_inner?mode=" + urlArgs + "&target_product_id=" + targetProductId + "&api_key=" + targetAPIKey)
  
    insert(el, buttonFrame);
  
    var iframe = document.createElement("iframe");
  
    var iframeCSS = 'position: fixed;\nleft: 0;\ntop: 0;\nwidth: 100%;\nheight: 100%;\nz-index: 9999;\ndisplay: none;';
  
    // Fix for an iframe scrolling issue present on iOS
    var userAgent = window.navigator.userAgent;
    if (userAgent.match(/iPad/i) || userAgent.match(/iPhone/i)) {
      var body = document.body,
          html = document.documentElement;
  
      var height = Math.max( body.scrollHeight, body.offsetHeight,
                             html.clientHeight, html.scrollHeight, html.offsetHeight );
      iframeCSS = iframeCSS.replace("position: fixed", "position: absolute; min-height: " + height + "px");
    }
  
    iframe.setAttribute('frameBorder', '0');
    iframe.id = `findation-iframe-${productId}`;
    iframe.setAttribute('allowtransparency', 'true');
    bind(iframe, 'load', function() {
      return iframe.style.visibility = 'visible';
    });
    iframe.style.cssText = iframeCSS;
  
    iframe.src = findationUrl("/widget_searches/new?mode=" + urlArgs + "&target_product_id=" + targetProductId + "&api_key=" + targetAPIKey)
  
    bind(window, "message", function(event) {
      const sourceIframe = Array.from(document.querySelectorAll('iframe')).find(
        frame => frame.contentWindow === event.source
      );

      if(event.data == "overlayClose") {
        iframe.style.display = 'none';
      } else if(event.data == "overlayOpen") {

        if (sourceIframe.id !== `findation-button-iframe-${productId}`) {
          return;
        }

        iframe.style.display = 'block';
        iframe.contentWindow.postMessage("overlayOpen", iframe.src);
  
        // Fix for an iframe scrolling issue present on iOS
        var userAgent = window.navigator.userAgent;
        if (userAgent.match(/iPad/i) || userAgent.match(/iPhone/i)) {
          window.scrollTo(0,0);
        }
        if(typeof findationWidgetOpen === "function") {
          findationWidgetOpen();
        }

      } else if(event.data == "buttonLoadSuccess") {
        // Now load iframe
        document.body.appendChild(iframe);
        buttonFrame.style.width = "100px";
        buttonFrame.style.height = "20px";
        buttonFrame.style.margin = "0 auto";
      }
    });
  }).call(this);
}

(function() {
  'use strict';

  window.okeConnectApi = window.okeConnectApi || {};
  window.okeConnectApi.recommendedProductsMounted = async (recommendationSection, products) => {
    // need elements to be rendered - wait for 1 second
    await new Promise(resolve => setTimeout(resolve, 1000));

    products.forEach((product, index) => {
      const productId = product.productId.replace('shopify-', '');
      const script = document.createElement('script');
      script.id = `findation-widget-button-${productId}`;
      script.type = 'text/javascript';
      script.src = 'https://www.findation.com/javascripts/widgetv1.js';
      script.async = true;

      script.setAttribute('data-api-key', 'ae8103982b29918d6ce44396073e783ed0b2d6bd0a65347ded4c49dad8ec');

      const productElement = recommendationSection.querySelectorAll(`.l-productRow--grid > .l-productRow-item .c-recommendedProduct-nameAndPrice`)[index];
      productElement.appendChild(script);

      renderFindationWidget({
        buttonId: `findation-widget-button-${productId}`,
        productUrl: `${product.url}?variant=${product.variants[0].variantRemoteId}`,
        productId: productId,
      });
    });
  };
})();